import React, { useState, useContext, useEffect } from "react";
import "./PaymentMethod.scss";
import AppContext from "../../config/AppContext";
import { ReactComponent as CreditArrow } from "../../assets/images/ralvie/creditarrow.svg";
import { getCardDetails, getloggedCompanySubscription, pauseSubscription, resumeSubscription, updateCardSubscription } from "../../services/Subscription";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import DisableAutoPopup from "./DisableAutoPopup";
import { Box, CircularProgress, Typography, Tooltip } from "@mui/material";
import RedirectPage from "./RedirectPage";
import { sidebarContext } from "../../util/context";

const PaymentMethod = () => {
  const [isActive, setIsActive] = useState(true);
  const { mode } = useContext(AppContext);
  const { t } = useTranslation();
  const { subscriptionDetails, setSubscriptionDetails } = useContext(sidebarContext);
  const [subscriptionDetail, setSubscriptionDetail] = useState([]);
  const [autoCollect, setAutoCollect] = useState(false);
  const [isDisableOpen, setIsDisableOpen] = useState(false);
  const [isEnableOpen, setIsEnableOpen] = useState(false);
  const [isAutoPaymentLoading, setIsAutoPaymentLoading] = useState(false);
  const [cardDetails, setCardDetails] = useState({});
  const [openRedirectPage, setOpenRedirectPage] = useState(false);


  useEffect(() => {
    getloggedCompanySubscription().then((res) => {
      if (res.data?.code === "RCI0000") {
        setSubscriptionDetail(res.data?.data);
        setSubscriptionDetails(res.data?.data);
        setAutoCollect(res.data?.data.autoCollect);

        getCardDetails(res.data?.data.user.customerId).then((res) => {
          if (res.data.code === "RCI0000") {
            setCardDetails(res.data.data);
          }
        });

      }
    });
    
  }, [])

  const pauseSub = (subscriptionId) => {
    setIsAutoPaymentLoading(true);
    pauseSubscription(subscriptionId).then((res) => {
      if (res.data.code === "RCI0048") {
        setAutoCollect(false);
        // window.location.reload();
        getloggedCompanySubscription();
        toast.success(t("RAL0900"));
       
      } else {
        toast.error(t("RAL0901"));
      }
      setIsAutoPaymentLoading(false);
    });
  }

  const resumeSub = (subscriptionId) => {
    setIsAutoPaymentLoading(true);
    resumeSubscription(subscriptionId).then((res) => {
      if (res.data.code === "RCI0047") {
        setAutoCollect(true);
        // window.location.reload();
        getloggedCompanySubscription();
        toast.success(t("RAL0898"));
        
      } else {
        toast.error(t("RAL0899"));
      }
      setIsAutoPaymentLoading(false);
    });

  }

  const updateCardSub = (subscriptionId) => {
    setOpenRedirectPage(true);
    const payload = {
      "subscription_id": subscriptionId
      // "redirect_url": `http://localhost:3000/subscription-me`
    }
    updateCardSubscription(payload).then((res) => {
      if (res.data.code === "RCI0049") {
        setOpenRedirectPage(false);
        window.location.href = res.data.data.url;
      } else {
        toast.error(t("RAL0941"));
      }
    });
  }

  const handleSwitch = (event) => {
    if (event) {
      setIsEnableOpen(true);

    } else {
      setIsDisableOpen(true);
    }
  }

  const checkSubscriptionStatusBtn = () => {
    if(Object.keys(cardDetails).length === 0){
      return true;
    }
    return subscriptionDetail.status === 'expired' ||
    subscriptionDetail.status === 'cancelled' ||
    subscriptionDetail.status === 'non_renewing';
   }

  const checkSubscriptionStatus = () => {
    return subscriptionDetail.status === 'expired' ||
    subscriptionDetail.status === 'cancelled' ||
    subscriptionDetail.status === 'non_renewing';
   }

  const getMonth = (month) => {
    if (month && month.length > 1) {
      return month;
    }

    return '0' + month;
  }


  return (
    <div className={mode === "dark" ? "payment-method-containerDark" : "payment-method-container"}>
     {openRedirectPage ?  <RedirectPage/> : <></>}
      <div className="paymentfirst-section">
        <span className={mode === "dark" ? "payment-methodtitleDark" : "payment-methodtitle"}>{t("RAL0922")}</span>
        <span className={mode === "dark" ? "payment-methodsubtitleDark" : "payment-methodsubtitle"}>{t("RAL0923")}</span>
      </div>

      <div className="payment-details">
        <div className={mode === "dark" ? "bank-cardDark" : "bank-card"}>
          <div className="creditapply">
            <span className="bank-name"></span>
            <Tooltip title={t("RAL0924")}><span className={mode === "dark" ? "card-typeDark" : "card-type"}>{t("RAL0924")}</span></Tooltip>
          </div>
          <div className="bankCardAlign">
            <div className="bank-status">
              <span className={`status-indicator ${isActive ? "active" : "inactive"}`}></span>
              <span className={mode === "dark" ? "ActivelabelcolorDark" : "Activelabelcolor"}>{isActive ? t("RAL0232") : t("RAL0233")}</span>
            </div>
            <div >
              <CreditArrow className={mode === "dark" ? "Arrowicondark" : "Arrowicon"} />
            </div>
          </div>
        </div>

        <div>
          <div className={mode === "dark" ? "card-infoDark" : "card-info"}>
            <div className="card-infoVisa">
              <span className={mode === "dark" ? "card-numberDark" : "card-number"}>{t("RAL0925") +
                (cardDetails?.last_four_digits ? cardDetails.last_four_digits : '0000')}</span>
              <span className={mode === "dark" ? "card-expiryDark" : "card-expiry"}>{t("RAL0926") +
                (cardDetails?.expiry_month ? getMonth(cardDetails.expiry_month) : '00') + "/" +
                (cardDetails?.expiry_year ? cardDetails?.expiry_year : '0000')}</span>
            </div>
          </div>
          <div>
            <button className={mode === "dark" ? "change-payment-Darkmode" : "change-payment-mode"}
              disabled={checkSubscriptionStatusBtn()}
              style={{
                cursor: checkSubscriptionStatusBtn() ? 'not-allowed' : 'pointer'
              }}
              onClick={() => {
                updateCardSub(subscriptionDetail.id);
              }}>
              <span className="cardarrowicon">⇅</span> {t("RAL0927")}
            </button>
          </div>
        </div>
      </div>
      <div className={mode === "dark" ? "dividerpaymentcarddark" : "dividerpaymentcard"}></div>

      <div className="auto-pay">
        <span className={mode === "dark" ? "AutopayenableDark" : "Autopayenable"}>{t("RAL0928")}</span>
        <div className={`switch-container ${mode === "dark" ? "dark-mode" : ""}`}>
        {isAutoPaymentLoading ? (<Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            // height="300px"
        >
          <CircularProgress />
        </Box>) :
         ( <label className="Autoswitch">
            <input type="checkbox" checked={checkSubscriptionStatusBtn() ? false : autoCollect}
              disabled={checkSubscriptionStatusBtn()}
              onChange={(value) => {
                handleSwitch(value.target.checked);
              }} />
            <span className="Autoslider"></span>
          </label>)}
        </div>

      </div>
      <DisableAutoPopup
        open={isDisableOpen}
        onClose={()=>{
          setIsDisableOpen(false);
        }}
        onConfirm={()=>{
          pauseSub(subscriptionDetail.id);
        }}
        title={t("RAL0952")}
        content={
          <>
          <Typography>
            {t("RAL0943")}
          </Typography>
          <Typography>
            {t("RAL0944")}
          </Typography>
          </>
        }
        confirmText={t("RAL0946")}
        cancelText={t("RAL0945")}
      />

<DisableAutoPopup
        open={isEnableOpen}
        onClose={()=>{
          setIsEnableOpen(false);
        }}
        onConfirm={()=>{
          resumeSub(subscriptionDetail.id);
        }}
        title={t("RAL0947")}
        content={
          <>
          <Typography>
            {t("RAL0948")}
          </Typography>
          <Typography>
            {t("RAL0949")}
          </Typography>
          </>
        }
        confirmText={t("RAL0951")}
        cancelText={t("RAL0950")}
      />

    </div>
  );
};

export default PaymentMethod;